/**
 * Collapses runs of `&` in the query portion (e.g. `?state=a&&code=b` → `?state=a&code=b`).
 * Literal `&` in values should be percent-encoded as `%26` and is left unchanged.
 */
export function normalizeRepeatedAmpersandsInSearch(search: string): string {
  if (!search.startsWith('?')) return search;
  const query = search.slice(1).replace(/&+/g, '&');
  return query.length > 0 ? `?${query}` : '';
}
